import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

// componentes
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Form, Row, Col } from 'react-bootstrap';
import { DebounceInput } from 'react-debounce-input';
import { Link } from 'react-router-dom';
import ListaCheckbox from './../../../Componentes/ListaCheckbox';

// cria os parametros
function Parametros({
    parametros, 
    alterarParametros, 
    // ...props
    login
}){

    // expande filtros
    let [mostrarMais, expandirParametros] = useState(false); 
    let [carregandoUsuarios, usuariosCarregado] = useState(true);

    // parametros
    return <div className="parametros">
        <div className="parametros-inicial">
            { parseInt(login.permissao.dispositivos) > 2 &&
                <Link to='/painel/dispositivos/cadastrar'>
                    <Button variant="padrao" className="botao-cadastrar">
                        <FontAwesomeIcon className="icone" icon={["fas", "plus"]} />
                        <span>Cadastrar Dispositivo</span>
                    </Button>
                </Link>
            }
            <DebounceInput 
                placeholder="" 
                debounceTimeout={400}
                element={Form.Control} 
                value={parametros.texto}
                onChange={(e) =>{
                    alterarParametros({...parametros, texto: e.target.value, pagina: 1})
                }}
            />
            <div className="campo-flags">
                <ListaCheckbox 
                    itens={[
                        {id: 'S', label: 'Ativos'},
                        {id: 'N', label: 'Inativos'}
                    ]}
                    value={parametros.ativo}
                    label='ativo-inativo'
                    onChange={(ids) => {
                        parametros.ativo = ids;
                        alterarParametros({...parametros, pagina: 1});
                    }}
                />
            </div>
            {!mostrarMais && <Button 
                variant="padrao"
                onClick={() => expandirParametros(true)}
            >
                <FontAwesomeIcon className="icone" icon={["fas", "search-plus"]} />
            </Button>}
        </div>

        {mostrarMais && 
            <Row className='mt-3'>
                <Col md='9'>

                </Col>
            </Row>
        }
    </div>

}

// importa states
let mapStateToProps = function(state){
    let estado = {
        login: state.login
    }
    return estado;
};

// retorna página de consulta
export default connect(mapStateToProps)(Parametros);